import React from "react";
import { useSelector } from "react-redux";

const Search = ({ search, onSearchChange, onClear }) => {
  const darkMode = useSelector((state) => state.theme.darkMode);

  return (
    <div>
      <div className="form-group">
        <div className="input-group">
          <input
            id="search"
            name="search"
            placeholder="Search"
            className="form-control searchField"
            value={search}
            onChange={onSearchChange}
            style={
              darkMode
                ? { borderRightWidth: 0, borderColor: "#ccc" }
                : { borderRightWidth: 0 }
            }
          />
          <div className="input-group-append">
            <button
              className={
                search
                  ? "btn btn-outline-danger btn-search"
                  : "btn btn-outline-dark btn-search"
              }
              type="button"
              style={{
                borderWidth: 0.5,
                borderColor: "#ccc",
                borderLeftWidth: 0,
              }}
              onClick={onClear}
            >
              <i
                className={search ? "fa fa-times" : "fa fa-search"}
                style={{ color: darkMode ? "#ccc" : "#555" }}
              />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Search;
